import {FaPauseCircle } from "react-icons/fa";

const PauseIcon = () => {
    return (<FaPauseCircle
        background-color="#012501"
        color="#01dd01"
        size="2em"
        border="10px"
        
        />)

}

export default PauseIcon;